<template>
  <div/>
</template>

<script>
import LaravelEcho from "laravel-echo";
import Pusher from "pusher-js";

export default {
  props: {
    id: Number,
    companyId: Number
  },

  mounted() {
    window.Echo = new LaravelEcho({
      broadcaster: "pusher",
      key: window.pusherKey,
      cluster: "eu",
      encrypted: true
    });

    Echo.channel("user." + this.id).listen(
      "NotificationCreated",
      ({ notification }) => {
        const {
          type,
          object_id,
          company_id,
          task_name,
          company_name
        } = notification;
        let toastSettings = {
          position: "topRight",
          theme: "dark",
          timeout: false,
          icon: "material-icons",
          backgroundColor: "#ff6736"
        };
        let className = "notification-toast";
        let icon = null;
        let title = "Уведомление для компании «" + company_name + "»";
        let message = null;
        let link = null;

        switch (type) {
          case CONST.notifications.status.taskCreated:
            message = "Новая задача «" + task_name + "»";
            icon = "fiber_new";
            link = "/tasks/" + object_id;
            break;
          case CONST.notifications.status.commentCreated:
            message = "Новый комментарий к задаче «" + task_name + "»";
            icon = "comment";
            link = "/tasks/" + object_id;
            break;
          case CONST.notifications.status.taskCanceled:
            message = "Задача «" + task_name + "» отменена";
            icon = "cancel";
            link = "/tasks/" + object_id;
            break;
          case CONST.notifications.status.taskClosed:
            message = "Задача «" + task_name + "» закрыта";
            icon = "close";
            link = "/tasks/" + object_id;
            break;
          case CONST.notifications.status.taskStatusChanged:
            message = "Статус задачи «" + task_name + "» изменен";
            icon = "autorenew";
            link = "/tasks/" + object_id;
            break;
          case CONST.notifications.status.listDocsUpdated:
            message = "Обновился срок предоставления документов поставщиков";
            icon = "schedule";
            link = "/documents/";
            break;
          case CONST.notifications.status.listDocsUpdatedClients:
            message = "Обновился срок предоставления документов покупателей";
            icon = "schedule";
            link = "/purchase-documents/";
            break;
          default:
            break;
        }

        toastSettings.iconText = icon;
        toastSettings.message = message;
        toastSettings.title = title;
        if (company_id == this.companyId && link) {
          toastSettings.onOpened = (instance, toast) => {
            toast.addEventListener("click", ({ target }) => {
              if (target.className !== "iziToast-close")
                window.location.href = link;
            });
          };

          className += " notification-toast--clicable";
        }
        toastSettings.class = className;

        iziToast.show(toastSettings);

        this.$store.commit("unshiftNotification", notification);
      }
    );
  }
};
</script>
